import { Control } from "ol/control";
import { useContext, useEffect, useState } from "react";
import olMap from "ol/Map";
import MapContext from "../map/MapContext";
import ReactDOM from "react-dom";

class ToolBarControl extends Control {
  constructor(element: HTMLElement) {
    super({
      element: element,
    });
  }
}

export interface ToolBarProps {
  children: React.ReactNode;
  className: string;
}

const ToolBar = ({ children, className }: ToolBarProps) => {
  const [container] = useState(document.createElement("div"));
  container.className = className;
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};
    const control = new ToolBarControl(container);
    map.addControl(control);

    return () => {
      if (!map) return;
      map.removeControl(control);
    };
  }, [map]);

  return ReactDOM.createPortal(children, container);
};

export default ToolBar;
